import { DrawerModal } from '@george-labs.com/design-system';

import { ErrorBoundary } from './ErrorBoundary';

export const DrawerModalWithErrorBoundary: typeof DrawerModal = (props) => {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <DrawerModal {...props}>
            <ErrorBoundary>{props.children}</ErrorBoundary>
        </DrawerModal>
    );
};
